<script>
    export let tooltipText = null;
</script>

{#if tooltipText}
  <a href="#" class="tooltip-icon">
    <i class="fas fa-question-circle" />
  </a>
  <div class="tooltip-custom">
    <div class="alert alert-warning" style="margin-bottom: 0;">
      <ul style="list-style: outside;" class="pl-2">
        {#each tooltipText as text}
          <li>{text}</li>
        {/each}
      </ul>
    </div>
  </div>
{/if}

<style>
  .tooltip-custom {
    display: none;
    background-color: white;
    color: black;
    border: 1px solid #ccc;
    border-radius: 5px;
    position: absolute;
    z-index: 1;
    max-width: 500px;
  }
  .tooltip-icon {
    vertical-align: middle;
    color: #a3a3a3;
  }
  .tooltip-icon:hover + .tooltip-custom {
    display: block;
  }
</style>
